import React from 'react';

const HomeIcon = ({ opacity }) => {
    return (
        <svg
            width='22'
            height='22'
            viewBox='0 0 22 22'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M13.7266 20.1163V14.818C13.7266 14.5838 13.6308 14.3592 13.4603 14.1936C13.2899 14.028 13.0586 13.935 12.8175 13.935H9.18115C8.94005 13.935 8.70882 14.028 8.53833 14.1936C8.36784 14.3592 8.27206 14.5838 8.27206 14.818V20.1163C8.27206 20.3504 8.1763 20.575 8.00583 20.7406C7.83537 20.9062 7.60417 20.9993 7.36308 20.9993L1.9092 21C1.78981 21 1.67158 20.9772 1.56128 20.9328C1.45097 20.8884 1.35074 20.8234 1.26631 20.7414C1.18188 20.6594 1.1149 20.5621 1.06921 20.4549C1.02352 20.3478 1 20.2329 1 20.117V9.91136C1 9.78834 1.02646 9.66667 1.0777 9.55416C1.12893 9.44165 1.2038 9.34079 1.29751 9.25802L10.3878 1.22969C10.5551 1.0819 10.7732 1.00001 10.9993 1C11.2255 0.999993 11.4436 1.08187 11.6109 1.22965L20.7024 9.25802C20.7962 9.34078 20.8711 9.44166 20.9223 9.55417C20.9735 9.66669 21 9.78836 21 9.91139V20.117C21 20.2329 20.9765 20.3478 20.9308 20.4549C20.8851 20.5621 20.8181 20.6594 20.7337 20.7414C20.6493 20.8234 20.549 20.8884 20.4387 20.9328C20.3284 20.9772 20.2102 21 20.0908 21L14.6356 20.9993C14.3945 20.9993 14.1633 20.9062 13.9928 20.7406C13.8224 20.575 13.7266 20.3504 13.7266 20.1163Z'
                stroke={'black'}
                opacity={opacity}
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default HomeIcon;
